import React, { Component } from 'react'

import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import DatePicker from 'material-ui/DatePicker';
import Select from 'react-select';

import ReactEcharts from 'components/ReactECharts';
import CHARTCONFIG from 'constants/ChartConfig';

import $ from 'jquery';

import { jsPDF } from '../../../vendor/jspdf.umd.min.js';

import Box from '../ui/Box';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import Helper from '../../services/Helper'; var help = Helper;
import MessageService from '../../services/MessageService'; var _mqtt = MessageService;

// avg_energy is joules, same as the older energy_data endpoint
const JOULES_IN_KWH = 3600000;

// ENERGY_MET_3 is a real three phase SKU that a plain "ENERGY_METER" prefix would miss
const METER_IDENTIFIER = /^ENERGY_MET(?:ER)?(?:_|$)/;
// the digit straight after the prefix is the phase count, the trailing _SW_n is the switch count
const METER_PHASES = /^ENERGY_MET(?:ER)?_(\d)/;

// "custom" is an unimplemented branch server side and comes back undefined, so it is not offered here
const INTERVALS = [
  { value: 'today', label: 'Today' },
  { value: 'day', label: 'A Day' },
  { value: 'month', label: 'A Month' }
];

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const MONTH_SHORT = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];

const ACCENT = '#f57c00';

// how many years back the month picker offers, current year included
const YEARS_BACK = 4;

const CHART_TEMPLATE = {
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: ['Energy Consumption'],
    textStyle: {
      color: CHARTCONFIG.color.text
    }
  },
  toolbox: {
    show: true,
    feature: {
      saveAsImage: {
        show: true,
        title: 'Save',
        name: 'EnergyMeter'
      },
      dataView: {
        show: true,
        readOnly: true,
        title: 'View',
        lang: ['Energy Consumption Report', 'Close'],
        buttonColor: 'rgb(0, 188, 212)'
      }
    }
  },
  calculable: true,
  xAxis: [
    {
      type: 'category',
      // bars sit inside the band rather than on the tick, unlike the line chart this replaced
      boundaryGap: true,
      data: [],
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          color: CHARTCONFIG.color.text
        }
      },
      splitLine: {
        lineStyle: {
          color: CHARTCONFIG.color.splitLine
        }
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
      axisLabel: {
        formatter: '{value} kWh',
        textStyle: {
          color: CHARTCONFIG.color.text
        }
      },
      splitLine: {
        lineStyle: {
          color: CHARTCONFIG.color.splitLine
        }
      },
      splitArea: {
        show: true,
        areaStyle: {
          color: CHARTCONFIG.color.splitArea
        }
      }
    }
  ],
  series: [
    {
      name: 'Energy Consumption',
      type: 'bar',
      barMaxWidth: 40,
      data: [],
      markPoint: {
        data: [
          { type: 'max', name: 'Max' },
          { type: 'min', name: 'Min' }
        ]
      },
      markLine: {
        data: [
          { type: 'average', name: 'Average' }
        ]
      }
    }
  ]
};

// hourly buckets come back as _id 0..23
function hourLabel(hour) {
  let h = parseInt(hour, 10);

  if (isNaN(h)) {
    return String(hour);
  }
  if (h === 0) {
    return '12AM - 1AM';
  }
  if (h < 11) {
    return h + 'AM - ' + (h + 1) + 'AM';
  }
  if (h === 11) {
    return '11AM - 12PM';
  }
  if (h === 12) {
    return '12PM - 1PM';
  }
  if (h < 23) {
    return (h - 12) + 'PM - ' + (h - 11) + 'PM';
  }
  return '11PM - 12AM';
}

function isEnergyMeter(device) {
  let identifier = device ? device.device_type_identifier : null;
  return typeof identifier === 'string' && METER_IDENTIFIER.test(identifier);
}

// null when the identifier carries no digit, e.g. a bare ENERGY_METER
function meterPhases(device) {
  if (device && device.have_3_phase_params) {
    return 3;
  }
  let identifier = device ? device.device_type_identifier : null;
  let match = typeof identifier === 'string' ? METER_PHASES.exec(identifier) : null;
  return match ? parseInt(match[1], 10) : null;
}

function reading(value, digits = 2) {
  if (value === undefined || value === null || value === '') {
    return '--';
  }
  let n = Number(value);
  return isNaN(n) ? String(value) : n.toFixed(digits);
}

export default class RoomEnergyMeter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hotel_room_id: this.props.room_main_id ? this.props.room_main_id : '',

      meters: [],
      selectedMeter: '',
      metersLoaded: false,
      live: null,

      interval: 'today',
      selectedDate: new Date(),
      maxDate: new Date(),
      chart: $.extend(true, {}, CHART_TEMPLATE),
      rows: [],
      totalKwh: 0,
      peak: null,
      loaded: false
    }

    this.onMqttMessage = this.onMqttMessage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('_mqt', this.onMqttMessage);
    this.getMeters();
    this.getEnergyData();
  }

  componentWillUnmount() {
    window.removeEventListener('_mqt', this.onMqttMessage);
  }

  getMeters() {
    if (!this.state.hotel_room_id) {
      this.setState({ metersLoaded: true });
      return;
    }

    ds.getDevicesInRoom(this.state.hotel_room_id,
      data => {
        let meters = (Array.isArray(data) ? data : [])
          .filter(isEnergyMeter)
          .map((device) => ({
            value: device.kd_id,
            label: device.device_name ? device.device_name : device.kd_id,
            identifier: device.device_type_identifier,
            phases: meterPhases(device)
          }));

        this.setState({
          meters: meters,
          selectedMeter: meters.length ? meters[0].value : '',
          metersLoaded: true
        }, () => {
          this.pingSelectedMeter();
        });
      },
      err => {
        this.setState({ meters: [], metersLoaded: true });
      }
    );
  }

  // the switches tab owns the mqtt connection, this only nudges the meter to report early
  pingSelectedMeter() {
    if (!this.state.selectedMeter) {
      return;
    }
    try {
      _mqtt.unsafePublish(this.state.hotel_room_id, this.state.selectedMeter);
    } catch (err) {
      // connection is not up yet, the device pushes on its own cadence anyway
      console.log(err);
    }
  }

  onMqttMessage(e) {
    if (!e || !e.detail || !this.state.selectedMeter) {
      return;
    }
    if (e.detail.device_id !== this.state.selectedMeter) {
      return;
    }
    let power = e.detail.data ? e.detail.data.power : null;
    if (power && typeof power === 'object') {
      this.setState({ live: power });
    }
  }

  changeMeter(value) {
    if (!value || value === this.state.selectedMeter) {
      return;
    }
    this.setState({ selectedMeter: value, live: null }, () => {
      this.pingSelectedMeter();
    });
  }

  selectedMeterDetails() {
    for (let meter of this.state.meters) {
      if (meter.value === this.state.selectedMeter) {
        return meter;
      }
    }
    return null;
  }

  buildPayload() {
    let interval = this.state.interval;
    let payload = {
      hotel_room_id: this.state.hotel_room_id,
      interval: interval
    };

    if (interval === 'today') {
      let now = new Date();
      let from = new Date(now);
      from.setHours(0, 0, 0, 0);

      return { ...payload, timeFrom: from.getTime(), timeto: now.getTime() };
    }

    if (interval === 'day') {
      let from = new Date(this.state.selectedDate);
      from.setHours(0, 0, 0, 0);

      let to = new Date(this.state.selectedDate);
      to.setHours(23, 59, 59, 999);

      return { ...payload, timeFrom: from.getTime(), timeto: Math.min(to.getTime(), new Date().getTime()) };
    }

    let d = new Date(this.state.selectedDate);
    let from = new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
    let to = new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);

    return { ...payload, timeFrom: from.getTime(), timeto: Math.min(to.getTime(), new Date().getTime()) };
  }

  bucketLabel(bucket) {
    // padded buckets only carry _id and avg_energy, so labels are built from _id alone
    if (this.state.interval === 'month') {
      let d = new Date(this.state.selectedDate);
      return MONTH_SHORT[d.getMonth()] + ' ' + bucket._id;
    }
    return hourLabel(bucket._id);
  }

  getEnergyData() {
    if (!this.state.hotel_room_id) {
      this.setState({ loaded: true, rows: [], totalKwh: 0, peak: null });
      return;
    }

    ds.postGetEnergyMeterData(this.buildPayload(),
      data => {
        // the server returns undefined rather than an error for unhandled intervals
        if (!data || !data.length) {
          this.setState({
            chart: $.extend(true, {}, CHART_TEMPLATE),
            rows: [],
            totalKwh: 0,
            peak: null,
            loaded: true
          });
          return;
        }

        // response is descending; _id is the bucket key (hour, or day of month)
        let sorted = data.slice().sort((a, b) => (parseInt(a._id, 10) || 0) - (parseInt(b._id, 10) || 0));

        let rows = [];
        let chartData = [];
        let labels = [];
        let total = 0;
        let peak = null;

        for (let bucket of sorted) {
          let kwh = Math.round((((Number(bucket.avg_energy) || 0) / JOULES_IN_KWH)) * 1000) / 1000;
          let label = this.bucketLabel(bucket);

          total += kwh;
          chartData.push(kwh);
          labels.push(label);
          rows.push({ label: label, kwh: kwh });

          if (!peak || kwh > peak.kwh) {
            peak = { label: label, kwh: kwh };
          }
        }

        let chart = $.extend(true, {}, CHART_TEMPLATE);
        chart.legend.data = [this.chartTitle()];
        chart.series[0].name = this.chartTitle();
        chart.series[0].data = chartData;
        chart.xAxis[0].data = labels;
        chart.toolbox.feature.saveAsImage.name = 'EnergyMeter - ' + this.chartTitle();

        this.setState({
          chart: chart,
          rows: rows,
          totalKwh: Math.round(total * 1000) / 1000,
          peak: peak,
          loaded: true
        });
      },
      err => {
        this.setState({
          chart: $.extend(true, {}, CHART_TEMPLATE),
          rows: [],
          totalKwh: 0,
          peak: null,
          loaded: true
        });
      }
    );
  }

  chartTitle() {
    let d = new Date(this.state.selectedDate);

    if (this.state.interval === 'today') {
      return "Today's Energy Consumption";
    }
    if (this.state.interval === 'day') {
      return 'Energy Consumption on ' + d.toDateString();
    }
    return 'Energy Consumption in ' + MONTH_NAMES[d.getMonth()] + ' ' + d.getFullYear();
  }

  changeInterval(interval, e) {
    if (interval === this.state.interval) {
      return;
    }
    this.setState({ interval: interval, loaded: false }, () => {
      this.getEnergyData();
    });
  }

  changeDate(e, date) {
    this.setState({ selectedDate: date, loaded: false }, () => {
      this.getEnergyData();
    });
  }

  monthOptions() {
    let now = new Date();
    let year = new Date(this.state.selectedDate).getFullYear();
    // a month that has not happened yet has no data, so do not offer it
    let last = year === now.getFullYear() ? now.getMonth() : 11;
    let options = [];

    for (let m = 0; m <= last; m++) {
      options.push({ value: m, label: MONTH_NAMES[m] });
    }
    return options;
  }

  yearOptions() {
    let now = new Date().getFullYear();
    let options = [];

    for (let y = now; y >= now - YEARS_BACK; y--) {
      options.push({ value: y, label: String(y) });
    }
    return options;
  }

  changeMonth(value) {
    let month = parseInt(value, 10);
    if (isNaN(month)) {
      return;
    }
    let year = new Date(this.state.selectedDate).getFullYear();

    this.setState({ selectedDate: new Date(year, month, 1), loaded: false }, () => {
      this.getEnergyData();
    });
  }

  changeYear(value) {
    let year = parseInt(value, 10);
    if (isNaN(year)) {
      return;
    }
    let now = new Date();
    let month = new Date(this.state.selectedDate).getMonth();

    // stepping back to the current year from an older one can leave the month in the future
    if (year === now.getFullYear() && month > now.getMonth()) {
      month = now.getMonth();
    }

    this.setState({ selectedDate: new Date(year, month, 1), loaded: false }, () => {
      this.getEnergyData();
    });
  }

  downloadCSV(e) {
    if (!this.state.rows.length) {
      return;
    }

    let fields = ['Period', 'Energy Consumed (kWh)'];
    let csvData = this.state.rows.map((row) => ({
      'Period': row.label,
      'Energy Consumed (kWh)': row.kwh
    }));

    help.exportToCSV(csvData, fields, this.chartTitle() + '.csv');
  }

  downloadPDF(e) {
    if (!this.state.rows.length) {
      return;
    }

    let doc = new jsPDF({ unit: 'mm', format: 'a4' });
    let pageWidth = doc.internal.pageSize.getWidth();
    let pageHeight = doc.internal.pageSize.getHeight();
    let margin = 14;
    let y = margin;

    doc.setFontSize(15);
    doc.text(this.chartTitle(), margin, y);
    y += 7;

    let meter = this.selectedMeterDetails();
    doc.setFontSize(9);
    doc.setTextColor(120);
    doc.text('Totalled across every energy meter in this room' + (meter ? ' (live panel showing ' + meter.label + ')' : ''), margin, y);
    y += 5;
    doc.text('Generated ' + new Date().toLocaleString(), margin, y);
    y += 8;

    doc.setFontSize(11);
    doc.setTextColor(0);
    doc.text('Total: ' + this.state.totalKwh + ' kWh', margin, y);
    if (this.state.peak) {
      doc.text('Peak: ' + this.state.peak.kwh + ' kWh (' + this.state.peak.label + ')', margin + 60, y);
    }
    y += 8;

    // chart image is best effort, the table below carries the same numbers
    try {
      if (this.chartInstance && this.chartInstance.getDataURL) {
        let image = this.chartInstance.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#ffffff' });
        let chartWidth = pageWidth - margin * 2;
        let ratio = this.chartInstance.getHeight() / this.chartInstance.getWidth();
        let chartHeight = chartWidth * (ratio > 0 ? ratio : 0.4);

        doc.addImage(image, 'PNG', margin, y, chartWidth, chartHeight);
        y += chartHeight + 8;
      }
    } catch (err) {
      console.log(err);
    }

    let rowHeight = 6;
    let drawTableHead = () => {
      doc.setFontSize(10);
      doc.setTextColor(120);
      doc.text('Period', margin, y);
      doc.text('Energy (kWh)', pageWidth - margin, y, { align: 'right' });
      y += 2;
      doc.setDrawColor(200);
      doc.line(margin, y, pageWidth - margin, y);
      y += rowHeight - 2;
      doc.setTextColor(0);
    };

    drawTableHead();

    for (let row of this.state.rows) {
      if (y > pageHeight - margin) {
        doc.addPage();
        y = margin;
        drawTableHead();
      }
      doc.setFontSize(10);
      doc.text(String(row.label), margin, y);
      doc.text(String(row.kwh), pageWidth - margin, y, { align: 'right' });
      y += rowHeight;
    }

    doc.save(this.chartTitle() + '.pdf');
  }

  renderPhaseBlock(label, current, voltage, pf, angle) {
    return (
      <div className="col-md-4" key={label}>
        <div style={{ border: '1px solid ' + CHARTCONFIG.color.gray, borderRadius: '3px', padding: '10px', marginBottom: '10px' }}>
          <div style={{ color: ACCENT, fontWeight: 500, marginBottom: '6px' }}>{label}</div>
          <div style={{ color: CHARTCONFIG.color.text }}>Current <b>{reading(current)}</b> A</div>
          <div style={{ color: CHARTCONFIG.color.text }}>Voltage <b>{reading(voltage)}</b> V</div>
          <div style={{ color: CHARTCONFIG.color.text }}>Power Factor <b>{reading(pf)}</b></div>
          <div style={{ color: CHARTCONFIG.color.text }}>Phase Angle <b>{reading(angle)}</b>&deg;</div>
        </div>
      </div>
    )
  }

  renderLive() {
    let meter = this.selectedMeterDetails();

    if (!this.state.metersLoaded) {
      return null;
    }

    if (!this.state.meters.length) {
      return (
        <div className="row" style={{ padding: '1vw 0' }}>
          <div className="col-md-12">
            <span style={{ color: CHARTCONFIG.color.text }}>No energy meter is paired to this room.</span>
          </div>
        </div>
      )
    }

    let live = this.state.live;

    if (!live) {
      return (
        <div className="row" style={{ padding: '1vw 0' }}>
          <div className="col-md-12">
            <span style={{ color: CHARTCONFIG.color.text }}>Waiting for {meter ? meter.label : 'the meter'} to report&hellip;</span>
          </div>
        </div>
      )
    }

    let isThreePhase = meter && meter.phases === 3;

    return (
      <div className="row" style={{ paddingTop: '6px', paddingBottom: '1vw' }}>
        <div className="col-md-12">
          <div style={{ marginBottom: '12px' }}>
            <span style={{ fontSize: '2rem', color: ACCENT, fontWeight: 500 }}>{reading(live.power, 0)}</span>
            <span style={{ color: CHARTCONFIG.color.text }}> W live power</span>
            <span style={{ color: CHARTCONFIG.color.text, paddingLeft: '15px' }}>
              Reactive <b>{reading(live.reactive, 0)}</b> W &nbsp;|&nbsp; Apparent <b>{reading(live.apparent, 0)}</b> W
            </span>
          </div>
        </div>

        {
          isThreePhase ?
            [
              this.renderPhaseBlock('Phase 1', live.c1, live.v1, live.pf1, live.pa1),
              this.renderPhaseBlock('Phase 2', live.c2, live.v2, live.pf2, live.pa2),
              this.renderPhaseBlock('Phase 3', live.c3, live.v3, live.pf3, live.pa3)
            ]
          :
            this.renderPhaseBlock('Live Readings', live.current, live.voltage, live.pf, live.pa)
        }
      </div>
    )
  }

  render() {
    return (
      <Box header='Energy Meter'>
        <div className="col-sm-12">

          <div className="row" style={{ paddingTop: '1vw', marginBottom: '24px' }}>
            <div className="col-md-7">
              {
                INTERVALS.map((item) => (
                  item.value === this.state.interval ?
                    <RaisedButton
                      key={item.value}
                      label={item.label}
                      primary
                      style={{ marginRight: '10px' }}
                    />
                  :
                    <FlatButton
                      key={item.value}
                      label={item.label}
                      primary
                      style={{ marginRight: '10px' }}
                      onClick={this.changeInterval.bind(this, item.value)}
                    />
                ))
              }

              {
                this.state.interval === 'day' ?
                  <div style={{ marginTop: '10px' }}>
                    <DatePicker
                      floatingLabelText="Select Date"
                      value={this.state.selectedDate}
                      maxDate={this.state.maxDate}
                      onChange={this.changeDate.bind(this)}
                      autoOk
                    />
                  </div>
                : null
              }

              {
                this.state.interval === 'month' ?
                  <div style={{ marginTop: '10px' }}>
                    <div style={{ display: 'inline-block', width: '160px', marginRight: '10px', verticalAlign: 'middle' }}>
                      <Select
                        id="energy_month"
                        options={this.monthOptions()}
                        simpleValue
                        clearable={false}
                        searchable={false}
                        name="selectedMonth"
                        value={new Date(this.state.selectedDate).getMonth()}
                        onChange={this.changeMonth.bind(this)}
                        placeholder="Month"
                      />
                    </div>

                    <div style={{ display: 'inline-block', width: '120px', verticalAlign: 'middle' }}>
                      <Select
                        id="energy_year"
                        options={this.yearOptions()}
                        simpleValue
                        clearable={false}
                        searchable={false}
                        name="selectedYear"
                        value={new Date(this.state.selectedDate).getFullYear()}
                        onChange={this.changeYear.bind(this)}
                        placeholder="Year"
                      />
                    </div>
                  </div>
                : null
              }
            </div>

            <div className="col-md-5">
              <Select
                id="energy_meter"
                options={this.state.meters}
                simpleValue
                clearable={false}
                searchable={this.state.meters.length > 5}
                name="selectedMeter"
                value={this.state.selectedMeter}
                onChange={this.changeMeter.bind(this)}
                disabled={this.state.meters.length < 2}
                placeholder={this.state.metersLoaded && !this.state.meters.length ? 'No energy meter in this room' : 'Select Energy Meter'}
              />
            </div>
          </div>

          {this.renderLive()}

          <div className="row">
            <div className="col-md-12">
              <p style={{ color: CHARTCONFIG.color.text, marginBottom: '0' }}>
                Total: <b>{this.state.totalKwh} kWh</b>
                {
                  this.state.peak ?
                    <span> &nbsp;|&nbsp; Peak: <b>{this.state.peak.kwh} kWh</b> ({this.state.peak.label})</span>
                  : null
                }
              </p>
              <small style={{ color: CHARTCONFIG.color.text }}>
                History below is the total of every energy meter in this room and does not follow the selection above.
                The endpoint resolves the meters server side and returns one summed series per room.
              </small>
            </div>
          </div>

          {
            this.state.loaded && !this.state.rows.length ?
              <div className="row" style={{ padding: '2vw 0', textAlign: 'center' }}>
                <span style={{ color: CHARTCONFIG.color.text }}>No energy data for this period.</span>
              </div>
            :
              <div className="row">
                <div className="col-md-12">
                  <ReactEcharts
                    option={this.state.chart}
                    showLoading={false}
                    onChartReady={(instance) => { this.chartInstance = instance; }}
                  />
                </div>
              </div>
          }

          <div className="row" style={{ paddingBottom: '1vw' }}>
            <div className="col-md-12 align-right">
              <RaisedButton
                label="Export CSV"
                primary
                type="button"
                disabled={!this.state.rows.length}
                onClick={this.downloadCSV.bind(this)}
              />

              <span className="space"></span>

              <RaisedButton
                label="Download PDF"
                secondary
                type="button"
                style={{ marginLeft: '10px' }}
                disabled={!this.state.rows.length}
                onClick={this.downloadPDF.bind(this)}
              />
            </div>
          </div>

        </div>
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./components/energymeter/RoomEnergyMeter.js